export default __webpack_public_path__ + "static/media/cert-general2024-hkgcsmeaa-sc.a040b940.jpg";